import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import banner2 from "../../assets/images/banner/moneyChit.jpeg";
import banner3 from "../../assets/images/banner/moneyChit2.avif";
import banner4 from "../../assets/images/banner/personaloan.avif";
import banner1 from "../../assets/images/banner/banner.jpg";

const Banner = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    arrows: false,
  };

  const banners = [
    {
      id: 1,
      image: banner1,
      title: "Gold Mortgage Scheme",
      text: "Golden Security Plan",
     
    },
    {
      id: 2,
      image: banner2,
       text: "Gold Chit Scheme",
      text2: "Golden Future Chit Plan",
      
    },
    {
      id: 3,
      image: banner3,
      title: "Money Chit Scheme",
      text: "Smart Savings Money Chit",
      
    },
    {
      id: 4,
      image: banner4,
      title: "Personal Loan",
      text: "Instant Personal Loan",
      
    },
  ];

  return (
    <div>
      {/* Carousel */}
      <div className="w-full">
       
        <Slider {...settings}>
          {banners.map((banner) => (
            <div key={banner.id} className="relative">
              {/* Responsive Image */}
              <img
                src={banner.image}
                alt={`Banner ${banner.id}`}
                className="w-full h-[50vh] sm:h-[60vh] md:h-[50vh] lg:h-[70vh] xl:h-[70vh] object-cover object-center rounded-lg shadow-md"
              />
              {/* Overlay Content */}
              <div className="absolute inset-0 bg-black bg-opacity-50 flex flex-col items-center justify-center  lg:justify-end text-center px-4">
                {/* Title */}
                {banner.title && (
                  <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold mb-4 text-gray-300 font-serif underline decoration-transparent decoration-2">
                    {banner.title}
                  </h1>
                )}
                {/* Text */}
                <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold mb-4 text-yellow-600 font-serif">
                  {banner.text}
                </h1>
                {/* Subtext */}
                <p className="mb-6 text-lg sm:text-xl md:text-2xl lg:text-3xl font-serif text-gray-200">
                  {banner.text2}
                </p>
                {/* Buttons */}
                <div className="mb-5 flex flex-wrap justify-center gap-4">
                 <a href="/">
                 <button className="bg-orange-500 hover:bg-orange-600 text-white font-bold py-2 px-4 rounded">
                    Read More
                  </button>
                 </a>
                  <a href="/">
                  <button className="bg-gray-500 hover:bg-gray-600 text-white font-bold py-2 px-4 rounded">
                    Contact Us
                  </button>
                  </a>
                </div>
              </div>
            </div>
          ))}
        </Slider>
       
      </div>
     
    </div>
  );
};

export default Banner;
